<script>
	import { onDestroy, createEventDispatcher } from 'svelte';
    import { toasts } from '../stores.js'

    export let copyText;

    const dispatch = createEventDispatcher();
	
	let textarea;
	
	onDestroy(() => {
		textarea.select();
        try {
		    document.execCommand('copy');
            dispatch('success');
        }
        catch {
            toasts.pushToast({})
            dispatch('err');
        } 
	});
</script>

<textarea bind:value={copyText} bind:this={textarea}></textarea>
